import { CSSProperties } from 'react';
import { stroke } from '~/styles/themes';

const CharacterChip = ({
  characters,
  style,
  size = 44,
}: {
  characters: {
    character_id: string;
    avatar_id: string;
    avatar_thumbnail_file_path: string;
  }[];
  style?: CSSProperties;
  size?: number;
}) => {
  return (
    <div style={{ ...style, display: 'flex' }}>
      {characters.map((character) => (
        <img
          key={character.avatar_id}
          src={character.avatar_thumbnail_file_path}
          alt='character thumbnail'
          width={size}
          height={size}
          style={{
            borderRadius: '999px',
            marginRight: -10,
            border: `1px solid ${stroke.stroke_1}`,
            objectFit: 'cover',
          }}
        />
      ))}
    </div>
  );
};

export default CharacterChip;
